import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import * as _ from 'lodash';

import { AppConfig } from '../../../app.settings';
import { Schedule } from '../../models/entities/schedule.type';
import { ScheduleRequestParameters } from '../../models/view-models/schedule-models/schedule-request-parameters.type';
import { TimelineRequestParameters } from '../../models/view-models/schedule-models/timeline-request-parameters.type';
import { ScheduleRequestResult } from '../../models/view-models/schedule-models/schedule-request-result.type';
import { TimelineRequestResult } from '../../models/view-models/schedule-models/timeline-request-result.type';
import { CreateScheduleDTO } from '../../models/view-models/schedule-models/create-schedule-dto.model';
import { UpdateScheduleDTO } from '../../models/view-models/schedule-models/update-schedule-dto.model';

@Injectable()
export class SchedulesService {
  private endpoint: string;

  constructor(private http: HttpClient, private config: AppConfig) {
    this.endpoint = `${this.config.getConfig('api')}Schedule`;
  }

  getSchedulesByScheduleRequest(
    requestParams: ScheduleRequestParameters
  ): Observable<ScheduleRequestResult> {
    return this.http.post<ScheduleRequestResult>(
      `${this.endpoint}/GetByScheduleRequest`,
      requestParams
    );
  }

  getSchedulesByTimelineRequest(
    requestParams: TimelineRequestParameters
  ): Observable<TimelineRequestResult> {
    return this.http.post<TimelineRequestResult>(
      `${this.endpoint}/GetByTimelineRequest`,
      requestParams
    );
  }

  getAllSchedules(): Observable<Schedule[]> {
    return this.http.get<Schedule[]>(
      `${this.endpoint}/GetAllByDate`);
  }

  turnOnSchedule(id: number) {
    return this.http.post(`${this.endpoint}/TurnOnSchedule/${id}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    });
  }

  createSchedule(body: CreateScheduleDTO): Observable<Schedule> {
    return this.http.post<Schedule>(`${this.endpoint}/AddScheduleForListOfMonitors`, body);
  }

  updateSchedule(body: UpdateScheduleDTO): Observable<Schedule> {
    return this.http.put<Schedule>(`${this.endpoint}/UpdateSchedule`, body);
  }

  turnOffSchedule(id: number) {
    return this.http.post(`${this.endpoint}/TurnOffSchedule/${id}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    });
  }

  deleteSchedule(id: number): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/RemoveSchedule/${id}`);
  }

  getOneSchedule(id: number): Observable<Schedule> {
    return this.http.get<Schedule>(`${this.endpoint}/${id}`);
  }

  removeSchedulesByPlaylistId(playlistId: number): Observable<void[]> {
    return this.getAllSchedules().pipe(
      map(schedules => schedules.filter(schedule => schedule.PlaylistId === playlistId)),
      filter(schedules => schedules.length > 0),
      switchMap(schedules =>
        forkJoin(schedules.map(schedule => this.deleteSchedule(schedule.Id))))
    );
  }
}
